import React, { useState } from 'react';
import { FontWeight } from '../../../styles/theme.mjs';
import { BreakingNewsType } from '../../../types/story.mjs';
import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import LittleArrowIcon from '../../Basic/Icons/LittleArrowIcon.mjs';
import { StyledBreakingNewsLink, StyledBreakingBannerFlexContainer, StyledBreakingBannerFlexTitle, StyledBreakingBannerTitleText, StyledBreakingBannerText, StyledBreakingBannerCloseButtonFlexContainer } from './BreakingNewsBanner.styles.mjs';
import { useTheme } from 'styled-components';

const BreakingNewsBanner = ({ title, description, type, href, onClose, onClick }) => {
    const theme = useTheme();
    const [isVisible, setIsVisible] = useState(true);
    const handleCloseClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsVisible(false);
        onClose && onClose();
    };
    const handleClick = (event) => {
        onClick && onClick(event);
    };
    return (React.createElement(StyledBreakingNewsLink, { href: href, isVisible: isVisible, onClick: handleClick },
        React.createElement(StyledBreakingBannerFlexContainer, { alignItems: "center", direction: ['column', 'row'], type: type, justifyContent: "space-between", isVisible: !isVisible },
            React.createElement(StyledBreakingBannerFlexTitle, { alignItems: "center", type: type, justifyContent: "center" },
                React.createElement(StyledBreakingBannerTitleText, { fontWeight: FontWeight.Semibold, tag: "p" }, title)),
            React.createElement(StyledBreakingBannerText, { type: type, fontWeight: FontWeight.Medium, tag: "p" },
                description,
                React.createElement(LittleArrowIcon, { fill: type === BreakingNewsType.NEWS || type === BreakingNewsType.PROMOTION
                        ? theme.colors.white
                        : theme.colors.iconColor })),
            React.createElement(StyledBreakingBannerCloseButtonFlexContainer, { direction: "row-reverse", type: type },
                React.createElement(IconButtonComponent, { type: "button", iconType: "close", onClick: handleCloseClick })))));
};

export { BreakingNewsBanner as default };
//# sourceMappingURL=BreakingNewsBanner.mjs.map
